import { Format, OnChangeEvent, GenerateHandleChangeFormatProps, OnChange } from "./types";
import { SelectChangeEvent } from "@mui/material";

const isUSPhoneNumberFormat = (phoneNumber: string) => {
  // Define the regular expression pattern
  const pattern = /^\(\d{3}\) \d{3}-\d{4}$/;

  // Test if the phoneNumber matches the pattern
  return pattern.test(phoneNumber);
};

const generateHandleChangeFormat = <T extends OnChange>({ setFormat, onChange, TextFieldRef, value }: GenerateHandleChangeFormatProps<T>) => {
  return (event: SelectChangeEvent) => {
    const newVal: Format = event.target.value as Format;

    setFormat(newVal);

    // only remove value if not in US format
    const isUSFormat = value ? isUSPhoneNumberFormat(value) : false;

    // Whenever the value is changing to US and there is a value - remove it as it will likely not fit the format
    if (newVal === "US" && value && !isUSFormat) {
      // Get the input element from the TextField for the name property (if it exists)
      const textFieldHasRefAndInput = TextFieldRef.current?.querySelector("input.MuiInputBase-input") as HTMLInputElement | null;

      // manually create an event to use for the onChange (only if ref and input elements exist)
      const ev: OnChangeEvent | null = textFieldHasRefAndInput
        ? {
            target: {
              value: "",
              name: textFieldHasRefAndInput.name,
            },
          }
        : null;

      // trigger onChange to reset the value
      ev && onChange(ev);
    }
  };
};

export { isUSPhoneNumberFormat, generateHandleChangeFormat };
